import React, { useState, useEffect, useMemo } from "react";
import { navigate } from "@reach/router";
import Axios from 'axios';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

/**********************************/
/**********************************/
/* UTILITIES FOR LIST OF CONTACTS */
/**********************************/
/**********************************/

/*
saveActualPageToStorage - saves it for example to actualPageEvents
*/

export function goToFirstPageUtilities(actualPage,saveActualPageToStorage) {
    localStorage.setItem(saveActualPageToStorage, 0);
    return 0;
}

export function goToPrevPageUtilities(actualPage,saveActualPageToStorage) {
    if((actualPage-1) < 0){
        localStorage.setItem(saveActualPageToStorage, actualPage);
        return actualPage;
    }
    else {
        localStorage.setItem(saveActualPageToStorage, actualPage-1);
        return actualPage-1;
    }
}

export function goToNextPageUtilities(actualPage, recordsOnOnePage, totalNumberOfContacts,saveActualPageToStorage) {
    var fromValue = (actualPage+1)*recordsOnOnePage;
    var toValue = (actualPage+2)*recordsOnOnePage;
    if( (fromValue >= totalNumberOfContacts)  && (toValue > totalNumberOfContacts) ){
        localStorage.setItem(saveActualPageToStorage, actualPage);
        return actualPage;
    }
    else {
        localStorage.setItem(saveActualPageToStorage, actualPage+1);
        return actualPage+1;
    }
}

export function goToLastPageUtilities(recordsOnOnePage, totalNumberOfContacts,saveActualPageToStorage) {
    var page = 0;
    while(( (page+1)*recordsOnOnePage) < totalNumberOfContacts){
        page = page+1;
    }
    localStorage.setItem(saveActualPageToStorage, page);
    return page;
}

export function moreRecordsOnPageUtilities(actualValue, recordsOnOnePageToStorage) {
    /*if(actualValue == 5){
        saveRecordsOnOnePageValue(25, recordsOnOnePageToStorage);
        return 25;
    }*/
    if(actualValue == 25){
        saveRecordsOnOnePageValue(50, recordsOnOnePageToStorage);
        return 50;
    }
    else if(actualValue == 50){
        saveRecordsOnOnePageValue(100, recordsOnOnePageToStorage);
        return 100;
    }
    else if(actualValue == 100){
        saveRecordsOnOnePageValue(250, recordsOnOnePageToStorage);
        return 250;
    }
    else if(actualValue == 250){
        saveRecordsOnOnePageValue(500, recordsOnOnePageToStorage);
        return 500;
    }
    else if(actualValue == 500){
        saveRecordsOnOnePageValue(1000, recordsOnOnePageToStorage);
        return 1000;
    }
    else if(actualValue == 1000){
        saveRecordsOnOnePageValue(1000, recordsOnOnePageToStorage);
        return 1000;
    }
    saveRecordsOnOnePageValue(25, recordsOnOnePageToStorage);
    return 25;
}

export function lessRecordsOnPageUtilities(actualValue, recordsOnOnePageToStorage) {
    if(actualValue == 1000){
        saveRecordsOnOnePageValue(500, recordsOnOnePageToStorage);
        return 500;
    }
    else if(actualValue == 500){
        saveRecordsOnOnePageValue(250, recordsOnOnePageToStorage);
        return 250;
    }
    else if(actualValue == 250){
        saveRecordsOnOnePageValue(100, recordsOnOnePageToStorage);
        return 100;
    }
    else if(actualValue == 100){
        saveRecordsOnOnePageValue(50, recordsOnOnePageToStorage);
        return 50;
    }
    else if(actualValue == 50){
        saveRecordsOnOnePageValue(25, recordsOnOnePageToStorage);
        return 25;
    }
    /*else if(actualValue == 25){
        saveRecordsOnOnePageValue(5, recordsOnOnePageToStorage);
        return 5;
    }
    else if(actualValue == 5){
        saveRecordsOnOnePageValue(5, recordsOnOnePageToStorage);
        return 5;
    }*/
    saveRecordsOnOnePageValue(25, recordsOnOnePageToStorage);
    return 25;
}

function saveRecordsOnOnePageValue(value, recordsOnOnePageToStorage){
    localStorage.setItem(recordsOnOnePageToStorage, value);
}

export function checkIfOutOfPages(actualPage, recordsOnOnePage, totalNumberOfContacts){
    var lastPage = goToLastPageUtilities(recordsOnOnePage, totalNumberOfContacts);
    if((((actualPage*recordsOnOnePage)+1) > totalNumberOfContacts) && actualPage != lastPage && totalNumberOfContacts != 0){
        return true;
    }
    return false;
}
